import { type ReactNode } from "react";

import { BdsIconCaretLargeRight, BdsText } from "@buildertrend/components";

import { formattedPlural } from "utilities/string/string";

import "./ActionCard.less";

export interface IActionCardProps {
    id: string;
    testid: string;
    icon: ReactNode;
    actionTextOne: string;
    actionTextOther: string;
    count: number;
    onClick: () => void;
    colorScheme?: "info" | "success" | "warning" | "error";
}

export const ActionCard: React.FC<IActionCardProps> = ({
    id,
    testid,
    icon,
    actionTextOne,
    actionTextOther,
    count,
    onClick,
    colorScheme = "info",
}) => {
    return (
        <div
            id={id}
            data-testid={testid}
            className={`action-card action-card--${colorScheme} flex bds-justify-start bds-items-center`}
            onClick={onClick}
        >
            {icon}
            <BdsText className="action-card__count" size="distinct-sm">
                {count}
            </BdsText>
            <BdsText size="distinct-sm">
                {formattedPlural({
                    value: count,
                    one: actionTextOne,
                    other: actionTextOther,
                })}
            </BdsText>
            <BdsIconCaretLargeRight className="action-card__arrow" size="sm" />
        </div>
    );
};
